'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M512 256c-282.77 0-512 229.228-512 512h64c0-212.078 171.922-384 384-384 9.6 0 19.108 0.386 28.532 1.080l-28.532 272.048h0.066c-38.284 22.126-64.066 63.476-64.066 110.872 0 70.694 57.308 128 128 128 70.694 0 128-57.306 128-128 0-47.396-25.782-88.746-64.064-110.872h0.066l-27.244-259.76c163.2 44.262 283.242 193.422 283.242 370.632h192c0-282.772-229.23-512-512-512z' })
    ));
};